import ConfirmButton from '@libs/useful/ConfirmButton'
import { __, sprintf } from '@libs/utilities'
import { ChangeEvent } from 'react'
import { Link, useParams } from 'react-router-dom'
import { IAdminStore, useAdminStore } from '../../data/store'
import DataTableCell from './DataTableCell'
import { getTableRows } from './utils'
import VisibleCheckBox from './VisibleCheckBox'
import { DIALOG_SIZE, IMenuItem, IPost } from '@libs/interfaces/layouts'
import { schema } from '@libs/layouts'
import actions from '@/modules/pe-basic-module/data/actions'
import { DELETE_SINGLE_TYPE, GET_FEED_ACTION } from '@/modules/pe-basic-module/data/actionTypes'
import { showToast } from '@libs/useful'
import { IBulk } from '../../data/interfaces'

export interface IDataRow {
    params: IDataRowParams,
    data_type: string
    item: IPost
}
export interface IDataRowParams {
    fields: IMenuItem
}

const DataTypeRow = (props: any) : JSX.Element => {
    const bulks: IBulk[]    = useAdminStore((state:IAdminStore) => state.bulks) 
    const setBulks: ((bulks: IBulk[]) => void)  = useAdminStore((state:IAdminStore) => state.setBulks) 
    const fields = { ...props.params.fields }
    const {landId} = useParams()
    const threads : any[] = getTableRows( fields )  

    const onChange  = (checked: boolean) => {
        const _bulks = bulks.map((bulk: IBulk) => {
            if(bulk.id === props.item.id) {
                bulk.checked = checked
            }
            return bulk
        }) 
        setBulks( _bulks )
    }
    const onDelete = () => {
        actions( 
            DELETE_SINGLE_TYPE, {
                land_id: landId,
                data_type: props.item.__typename,
                id: props.item.id
            }
        )
        .then(async () => {
            actions(
                GET_FEED_ACTION, 
                {
                    data_type: props.item.__typename,
                    land_id: landId,
                }
            )
            .then(async () => {
                showToast({
                    message: __("Feed updated")
                })
            })
            showToast({
                message: __("Successfully remove")
            })
        })
    }
    return ( 
        <tr data-testid="data-table-row" role="row">
            <td   data-testid="data-table-checkbox-cell" role="cell">
                <div className="">
                    <TableCheckBox 
                        {...props}
                        checked={ bulks.filter((bulk:IBulk) => bulk.id === props.item.id)[0]?.checked }
                        onChecked={onChange}
                    />
                    <VisibleCheckBox {...props} />
                </div>                
            </td>
            {
                threads.map((thread : string) => {
                    return <DataTableCell 
                        item={ props.item } 
                        thread={ thread } 
                        type={ fields.apollo_fields[thread].type }
                        default={ fields.apollo_fields[thread].default }
                        apollo_fields={ fields.apollo_fields[thread] }
                        key={thread} 
                        data_type={props.data_type}
                        className={ props.item.post_status && props.item.post_status !== "publish" ? "opacity_5 grayscale " : " "}
                    />
                })
            }
            <td  data-testid="data-table-edit-cell" role="cell" >
                <div className="d-flex w-100 align-items-center">
                    <Link className='table-btn flex-grow-100' to={`${props.item.id}`}  data-testid="data-table-edit-cell-link">
                        <span className='small'>{__("Edit")}</span>
                    </Link>
                    <ConfirmButton
                        onConfirm={onDelete}
                        buttonMinimal
                        buttonIcon="cross"
                        buttonClassName='pe-surface3 ml-2'
                        dialogClasssName={DIALOG_SIZE.MINIMAL}
                    >
                        <div className="p-4">
                            {sprintf( __("Really remove %s?"), props.item.title || __(schema()[props.item.__typename]?.name || "element" ) ) }
                        </div>
                    </ConfirmButton>
                </div> 
            </td>
        </tr>
    )
} 

export default DataTypeRow

export const TableCheckBox = (props: any) :JSX.Element => {     
    return <label className={`_check_blue_ ml-2 mt-1 mb-0 data-${ props.col }`}>
        <input
            type="checkbox"
            data-id={ props.id }
            value={ props.id }
            checked={ props.checked || false }
            onChange={ (evt:ChangeEvent<HTMLInputElement> ) =>  props.onChecked(evt.currentTarget.checked ) }
            data-testid="table-checkbox"
        />
    </label>
}